<template>
	<div class="noprint page-right-block">
		<ActiveSessionsWarning v-if="userStore.activeSessions > 1" />

		<achievements :is-in-monthly-top="isInMonthlyTop" :monthly-top-url="monthlyTopUrl" />

		<transition-height name="fade">
			<my-rewards v-show="routeName.indexOf('prizes') === 0" class="my-rewards-block" />
		</transition-height>
		
		<transition-height name="fade">
			<leaderboard v-show="routeName.indexOf('prizes') === -1 && settings.userFriendsEnabled" />
		</transition-height>

		<transition-height name="fade">
			<prizes-carousel v-show="routeName.indexOf('prizes') === -1" :key="routeName.indexOf('prizes') === -1" /> <!-- with :key force this component to reload -->
		</transition-height>

		<transition-height name="fade">
			<short-history v-show="routeName.indexOf('prizes') === -1 && routeName.indexOf('history') === -1" />
		</transition-height>

		<right-panel-footer v-if="!settings.ui.footerForceBottomOnDesktop || languagesSupported.length > 1" />
	</div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import Leaderboard from './leaderboard.vue'
import Achievements from './achievements.vue'
import ShortHistory from './short-history.vue'
import MyRewards from './my-rewards.vue'
import PrizesCarousel from './prizes-carousel.vue'
import RightPanelFooter from './right-panel-footer.vue'
import { useStore } from '@/js/stores/index';
import { useUserStore } from '@/js/stores/user'
import ActiveSessionsWarning from './active-sessions-warning.vue'

const store = useStore()
const userStore = useUserStore()
const route = useRoute()

// Computeds
const isInMonthlyTop = computed(() => userStore.isInMonthlyTop)
const monthlyTopUrl = computed(() => userStore.monthlyTopUrl)
const settings = computed(() => store.settings)
const languagesSupported = computed(() => store.settings.languagesSupported)
const routeName = computed(() => route.name || "")
</script>